import { gql } from "@apollo/client";

export const requestEmailVerification = gql`mutation RequestEmailVerification($input: requestEmailVerificationInput) {
    requestEmailVerification(input: $input)
  }`

export const requestPhoneVerification = gql`
mutation RequestPhoneVerification($input: checkPasswordAvailabilityInput) {
  requestPhoneVerification(input: $input) {
    code
    token
  }
}`

export const socialLogin = gql`
mutation SocialMediaLogin($token: String!, $platform: SocialPlatform!) {
  socialMediaLogin(token: $token, platform: $platform) {
    user {
      id
      shop {
        id
        name
        description
        contactEmail
        email
        currency
        slug
        primaryDomain
        sokoWorldDomain
        customDomains
        hasBeenSetup
        isActive
        shopTags
        createdAt
        updatedAt
        avatar
        country
        coverImage
        deliveryOption
        deliveryAgent
        locations {
          id
          lat
          long
          createdAt
          updatedAt
        }
        paymentOptions
        url
        shortUrl
        phone
        ownerId
        supplierId
        shopType
        shopId
      }
      email
      name
      country
      state
      phone
      verified
      first_order_created
      verifiedDetails {
        has_verified_phonenumber
        has_verified_email
        setup_complete
      }
      user_type
      username
      customers {
        id
        user_id
        name
        phone
        email
        address {
          id
          customer_id
          city
          lat
          lng
          area
          country
          landmark
        }
      }
      details {
        id
        gender
        dob
        referred_by
        user_id
      }
      paymentDetails {
        id
        user_id
        provider
        account_name
        account_number
        method
        type
      }
      google_id
      deviceToken
      facebook_id
      twitter_id
      supplier_shop_id
      created_at
      updated_at
      banned
      suspended
      suspended_by
      suspended_reason
      suspended_until
      suspended_at
      banned_by
      banned_until
      deleted
      accepted_terms
      hasReview
    }
    token
  }
}
`

export const releaseUser = gql `
mutation ReleaseUserAccount {
    releaseUserAccount
}`


export const removeUser = gql`
mutation RemoveUser($removeUserId: ID!) {
  removeUser(id: $removeUserId)
}
`

export const createAccountSecurity = gql`
mutation CreateAccountSecurity($input: CreateUserAccountSecurityInput!) {
  createAccountSecurity(input: $input) {
    user_id,userType,securityType,securityToken,
  }
}`

export const deleteAccountSecurity = gql`
mutation DeleteAccountSecurity($input: DeleteUserAccountSecurityInput!) {
  deleteAccountSecurity(input: $input)
}`

export const updateAccountSecurity = gql`
mutation UpdateAccountSecurity($input: UpdateUserAccountSecurityInput!) {
  updateAccountSecurity(input: $input) {
    user_id,securityType,securityToken,id
  }
}`

export const createMonthlyIncomeGoal = gql`
mutation CreateMonthlyIncomeGoal($userId: ID!, $incomeCategory: IncomeCategory!, $goal: GoalCategory!) {
  createMonthlyIncomeGoal(user_id: $userId, incomeCategory: $incomeCategory, goal: $goal)
}
`

export const verifyAccountSecurity = gql`
mutation VerifyAccountSecurity($input: VerifyUserAccountSecurityInput!) {
  verifyAccountSecurity(input: $input) {
    id
    shop {
      id
      name
      description
      contactEmail
      email
      currency
      slug
      primaryDomain
      sokoWorldDomain
      customDomains
      hasBeenSetup
      isActive
      shopTags
      createdAt
      updatedAt
      avatar
      country
      coverImage
      deliveryOption
      deliveryAgent
      locations {
        id
        lat
        long
        createdAt
        updatedAt
      }
      paymentOptions
      url
      shortUrl
      phone
      ownerId
      supplierId
      shopType
      shopId
    }
    email
    name
    country
    state
    phone
    verified
    first_order_created
    verifiedDetails {
      has_verified_phonenumber
      has_verified_email
      setup_complete
    }
    user_type
    username
    customers {
      id
      user_id
      name
      phone
      email
      address {
        id
        customer_id
        city
        lat
        lng
        area
        country
        landmark
      }
    }
    details {
      id
      gender
      dob
      referred_by
      user_id
    }
    paymentDetails {
      id
      user_id
      provider
      account_name
      account_number
      method
      type
    }
    google_id
    deviceToken
    facebook_id
    twitter_id
    supplier_shop_id
    created_at
    updated_at
    banned
    suspended
    suspended_by
    suspended_reason
    suspended_until
    suspended_at
    banned_by
    banned_until
    deleted
    accepted_terms
    hasReview
  }
}
`

export const notificationRead = gql`
mutation MarkNotificationAsRead($markNotificationAsReadId: ID) {
  markNotificationAsRead(id: $markNotificationAsReadId) {
    id
    title
    body
    type
  }
}
`

export const allNotificationsRead = gql `
mutation Mutation {
  markAllNotificationsAsRead
}
`